function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleReception2Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2 4.55a1.65 1.65 0 100 3.3 1.65 1.65 0 000-3.3zM5.55 6.2a3.65 3.65 0 117.3 0 3.65 3.65 0 01-7.3 0zM22.7 4.55a1.65 1.65 0 100 3.3 1.65 1.65 0 000-3.3zM19.05 6.2a3.65 3.65 0 117.3 0 3.65 3.65 0 01-7.3 0zM30 17H14.5v-2H30v2zM4 17H2v-2h2v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 14.5c0-2.202 1.798-4 4-4h3c2.202 0 4 1.798 4 4v5c0 1.11-.6 2.1-1.5 2.618V28c0 1.102-.898 2-2 2H7c-1.102 0-2-.898-2-2v-5.903c-.873-.516-1.5-1.45-1.5-2.597v-5zm4-2c-1.098 0-2 .902-2 2v5c0 .457.309.852.782.99a1 1 0 01.718.96V28h4v-6.55a1 1 0 01.771-.973c.388-.092.729-.48.729-.977v-5c0-1.098-.902-2-2-2h-3zM21 12.5c-1.098 0-2 .902-2 2v.5h7v-.5c0-1.098-.902-2-2-2h-3zm-4 2c0-2.202 1.798-4 4-4h3c2.202 0 4 1.798 4 4V16a1 1 0 01-1 1h-9a1 1 0 01-1-1v-1.5zM16.45 23.65c0-1.102.898-2 2-2h8.05c1.102 0 2 .898 2 2v4.313c.075 1.163-.884 2.037-1.95 2.037h-8.1c-1.102 0-2-.898-2-2v-4.35zm10.05 0h-8.05V28h8.05v-4.35z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.324 21.5h2.452a1.24 1.24 0 00-1.226-1 1.24 1.24 0 00-1.226 1zm-2.024.25a3.24 3.24 0 013.25-3.25 3.24 3.24 0 013.25 3.25v.75a1 1 0 01-1 1h-4.5a1 1 0 01-1-1v-.75z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3 21.65a1 1 0 011 1V29a1 1 0 11-2 0v-6.35a1 1 0 011-1zM24.7 21.65a1 1 0 011 1V29a1 1 0 01-2 0v-6.35a1 1 0 011-1z",
    fill: props.color
  }));
}

export default SvgIconPeopleReception2Filled;